import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import { Estado } from "../../actions/Estado";
import { GetPagos } from "../../actions/pagos";
import GetServicios from "../../actions/servicio";
import { GetProfesionales } from "../../actions/profesionales";

import style from "../../styles/form.module.css";
import { toast } from "react-toastify";

function ABMGiftcard() {
    const hoy = new Date(); 
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "giftcardpier";   
   const estados = [
      { id: 1, nombre: "Activo" },
      { id: 2, nombre: "Cancelado" },
      { id: 3, nombre: "Usado" },
   ];
   const { data: formasPago = [] } = GetPagos();
   const users = GetProfesionales() || [];
   const servicios = GetServicios() || [];
   const location = useLocation();
   const { state } = location;

   var urlIns = url;
   var metodo = "PUT";
   const navigate = useNavigate();
   const [input, setInput] = useState({
      id_primary: state ? state.id_primary : 0,
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      nombre: state ? state.nombre : "",
      documento_solicitante: state ? state.documento_solicitante : "",
      documento_cliente: state ? state.documento_cliente : "",
      tipoPago: state ? state.tipoPago : 1,
      usuario: state ? state.usuario : 0,
      total: state ? state.total : 1,
      serv_id: state ? state.serv_id : 0,
      fecha: hoy.toISOString().split("T")[0],
      cod_status: state ? state.cod_status : "1",
   });

   var btnGrabar = true;

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      let err = 0;   

      if (input.total === ""){
         err=1;
         toast.error("Debe ingresar el total de la Giftcard");
      }
         
      if (input.total <= 0){
            err=1;
            toast.error("La presentación del Giftcard debe ser mayor a cero");
      }

      if (input.documento_solicitante === ""){
            err=1;
            toast.error("Debe ingresar el documento_cliente del Giftcard");
      }

      if (input.serv_id === 0) {
         err=1;
         toast.error("Debe seleccionar un servicio");
      }

      if (input.id > 1) {
            
         if (input.documento_cliente !== "") {
            if (input.documento_cliente[0] === " " )
               err = 1;
               toast.error(
               "El documento cliente debe ser numerico",
            );
         }
      }
      if (err===1) return;
      
      console.log("input: ", input);
      urlIns = url + `/${input.id}`;
      metodo = "PUT";
      if (input.id === 0) {
         urlIns = url;
         metodo = "POST";
      }

      mutate(input);
      // console.log("input: ", input);
      // console.log("urlIns: ", urlIns);
      // console.log("metodo: ", metodo);
   };
   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(urlIns, {
            method: metodo,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (resp) => {
         console.log("resp: ", resp);
         if (resp?.message) {
            toast.error(resp.message);
            return;
         }
         window.location.href = "/giftcardpier";
      },
      onError: () => {
         alert("Error");
      },
   });

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">Datos del Gift Card</h1>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Gift Card Numero : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Nombre: </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Nombre comprador"
                        name="nombre"
                        value={input.nombre}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Documento  Solicitante:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="N° de documento del comprador"
                        name="documento_solicitante"
                        value={input.documento_solicitante}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  {input.id !== 0 ? (
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Documento Cliente:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="N° de documento del cliente"
                        name="documento_cliente"
                        value={input.documento_cliente}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  ) : null}
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Profesional</span>
                     <select
                        className={style.selData}
                        name="usuario"
                        id="usuario"
                        onChange={handleChange}
                        value={input.usuario || ""}
                     >
                        <option value="0">Seleccionar</option>
                        {users &&
                           users?.map((data) => {
                              return (
                                 <option
                                    value={data.id}
                                    key={data.id}
                                 >{`${data.username}`}</option>
                              );
                           })}
                     </select>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Total Gift Card:
                    </span>
                    <label htmlFor="total"></label>&nbsp;
                    <input
                        type="number"
                        id="total"
                        name="total"
                        value={input.total}
                        onChange={handleChange}
                        className={style.input_field_number}
                    />
                    </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                       Servicio :
                     </span>
                     <select
                        name="serv_id"
                        id="serv_id"
                        onChange={(e) => handleChange(e)}
                        value={input.serv_id}
                        className={style.input_small_field}
                     >
                        <option value="0">Seleccionar un servicio</option>
                        {servicios &&
                           servicios.map((dat) => {
                              if (dat.tipo === 1) {
                              return (
                                 <option
                                    value={ dat.id_primary}
                                    key={ dat.id_primary}
                                 >{`${dat.descripcion}`}</option>
                              );
                           }
                           })}
                     </select>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Forma de pago:</span>
                     <select
                        name="tipoPago"
                        id="tipoPago"
                        onChange={(e) => handleChange(e)}
                        value={input.tipoPago}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar forma de pago</option>
                        {formasPago.length > 0 &&
                           formasPago.map((dat) => {
                              return (
                                 <option value={dat.id || dat.id_primary} key={dat.id || dat.id_primary}>{`${dat.descripcion || dat.nombre}`}</option>
                              );
                           })}
                     </select>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/giftcardpier");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMGiftcard;
